// extracted by mini-css-extract-plugin
module.exports = {"notice":"FeatureTrialNotice_notice__3ymVR","badge":"FeatureTrialNotice_badge__k4far","link":"FeatureTrialNotice_link__wbBhy"};